{
    "api": {
        "BAD_AUTHENTICATION": "Invalid login",
        "ERR_NETWORK": "Network error. Please try again.",
        "ERR_BAD_RESPONSE": "An unexpected error occurred. If it occurs again, please contact the technical support.",
        "ERR_BAD_REQUEST": "An unexpected error occurred. If it occurs again, please contact the technical support.",
        "EXPIRED_TOKEN": "Token is expired !",
        "INVALID_API_KEY": "Invalid API key",
        "INVALID_CODE": "Invalid code",
        "INVALID_LOGIN": "Invalid login or password",
        "INVALID_TOKEN": "Invalid token",
        "INVALID_REQUEST": "An unknown error occurred",
        "TOKEN_NOT_FOUND": "Link is not valid.",
        "TOO_MANY_REQUESTS": "Too many attempts, try again in 60 sec.",
        "UNAVAILABLE_EMAIL": "This email is already taken",
        "UNEXPECTED_ERROR": "An unexpected error occurred. If it occurs again, please contact the technical support.",
        "UNKNOWN_ERROR": "An unknown error occurred.",
        "EMAIL_ALREADY_EXISTS": "This email is already taken",
        "envelopes": {
            "creation": {
                "INVALID_PARAMETER": "The couple IP address / port is invalid.",
                "RESOURCE_NOT_FOUND": "Organization and/or POS terminal not found.",
                "UNAUTHORIZED_PROVIDER": "You cannot schedule envelopes for this organization.",
                "SCHEDULED_START_DATE_IN_THE_PAST": "Schedule start date is in the past.",
                "SCHEDULED_END_DATE_IN_THE_PAST": "Schedule end date is in the past.",
                "ALREADY_EXISTING_ENVELOPE": "An envelope is already scheduled for this POS terminal.",
                "REDIS_CONNECTION": "We could not schedule this envelope, please contact support.",
                "INTERNAL_SERVER_ERROR": "An unknown error occurred.",
                "TOO_MANY_ITEMS_FOUND": "Organization name matches several different organizations.",
                "UNKNOWN_ERROR": "An unknown error occurred."
            }
        }
    }
}